import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-admin-new-species',
  templateUrl: './admin-new-species.component.html',
  styleUrls: ['./admin-new-species.component.css'],

})
export class AdminNewSpeciesComponent implements OnInit {

  breadcrumbMenuItems: MenuItem[] = []
  breadcrumbHome: MenuItem = {}

  profile: BasicUser | undefined

  constructor(
    private readonly _authService: AuthGateway,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    if (this.profile) {
      this.translate.use(this.profile.lang)
    }
    this.loadBreadcrumb()
  }

  loadBreadcrumb() {
    this.translate.get([
      'AdminSpeciesManagement.PageHomeTitle',
      'AdminSpeciesManagement.PageTitle',
      'AdminSpeciesManagement.CreateEditSpecie.NewSpecieTitle',
    ]).subscribe({
      next: (tranlations) => {
        this.breadcrumbHome = {
          label: tranlations['AdminSpeciesManagement.PageHomeTitle']
        }

        this.breadcrumbMenuItems = [
          {
            label: tranlations['AdminSpeciesManagement.PageTitle'],
            routerLink: ['/' + Routes.adminSpecies]
          },
          {
            label: tranlations['AdminSpeciesManagement.CreateEditSpecie.NewSpecieTitle'],
          }
        ]
      },
      error: () => {}
    })
  }
}
